






























import { defineComponent } from "@vue/composition-api";

export default defineComponent({
  name: "AvatarStoryOutline",
  props: {
    hasActiveStory: { type: Boolean, default: false },
  },
});
